import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/api";
import { useAuth } from "@/context/AuthContext";
import { APP } from "@/constants/testIds";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match?.[1];

    if (!session_id) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data.user);
        // clean hash and refetch to make sure cookie works
        window.history.replaceState(null, "", "/dashboard");
        await checkAuth();
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (err) {
        console.error("Auth callback failed:", err?.message);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div
        data-testid={APP.loadingSpinner}
        className="w-8 h-8 border-2 border-orange-600 border-t-transparent rounded-full animate-spin"
      />
    </div>
  );
}
